import { Card, Grid, Skeleton } from "@mantine/core";

export default function JobSmallCardSkeleton({ ...props }) {
  return (
    <Card padding={"lg"} style={{ borderRadius: "12px" }} withBorder {...props}>
      <Grid {...props}>
        <Grid.Col span={12}>
          <div className="flex flex-col">
            <div className="flex justify-between items-center">
              <div className="flex flex-wrap">
                <Skeleton height={24} width={80} radius="sm" mt={4} mx={4} />
                <Skeleton height={24} width={80} radius="sm" mt={4} mx={4} />
              </div>
              <div className="flex items-center justify-end mt-2 sm:mt-0 min-w-[100px] space-x-2">
                <Skeleton height={36} width={36} radius="md" />
                <Skeleton height={36} width={36} radius="md" />
              </div>
            </div>
            <Skeleton
              height={28}
              width={130}
              radius="xl"
              className="m-0 p-0 mt-[16px] mb-[16px]"
            />
            <div className="flex">
              <div className="flex items-center text-primary w-1/2">
                <Skeleton height={18} mt={0} mx={4} width={100} radius="xl" />
              </div>
              <div className="flex items-center mt-1 text-primary  w-1/2">
                <Skeleton height={18} mt={0} mx={4} width={100} radius="xl" />
              </div>
            </div>
            <div className="flex">
              <div className="flex items-center text-primary w-1/2">
                <Skeleton height={18} mt={0} mx={4} width={100} radius="xl" />
              </div>
              <div className="flex items-center mt-1 text-primary w-1/2">
                <Skeleton height={18} mt={0} mx={4} width={100} radius="xl" />
              </div>
            </div>
            <div className="flex items-center mt-[15px]">
              <Skeleton height={50} circle />

              <div className="flex flex-col ml-[12px]">
                <Skeleton height={22} mb={4} mx={4} width={100} radius="xl" />
                <div className="flex items-center">
                  <Skeleton height={16} mt={0} mx={4} width={100} radius="xl" />
                </div>
              </div>
            </div>
          </div>
        </Grid.Col>
      </Grid>
    </Card>
  );
}
